module.exports = __webpack_public_path__ + "static/media/cristo-rey.67e777ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/cristo-rey.jpg
// module id = 714
// module chunks = 0